import { Dumbbell, Activity, Hand, Eye, Ear, HeartPulse, UtensilsCrossed, Flower2 } from "lucide-react";

// Palette: "Sunlit garden" — vibrant, distinct hues per sensory system.
// Each system has a saturated `color` (used for text/icons), a soft tinted `bg`,
// a companion `border`, and an `accent` hex used for gradients / halos.
export const SYSTEMS = [
  {
    key: "proprioceptive",
    label: "Proprioceptive",
    boxLabel: "Proprioceptive Box",
    studentLabel: "Heavy Body Work",
    meaning: "Muscle & joint input, heavy work",
    icon: Dumbbell,
    color: "#2F6B4F",          // vivid forest
    bg: "#E4F3EA",
    border: "#B6DEC4",
    accent: "#4CB98A",
  },
  {
    key: "vestibular",
    label: "Vestibular",
    boxLabel: "Vestibular Box",
    studentLabel: "Move & Balance",
    meaning: "Movement and balance",
    icon: Activity,
    color: "#B57814",          // saffron/amber
    bg: "#FFF1D1",
    border: "#F4D890",
    accent: "#F4B740",
  },
  {
    key: "tactile",
    label: "Tactile",
    boxLabel: "Tactile Box",
    studentLabel: "Touch",
    meaning: "Touch and texture",
    icon: Hand,
    color: "#B54423",          // terracotta
    bg: "#FDE5D9",
    border: "#F5BFA6",
    accent: "#EB7A4F",
  },
  {
    key: "visual",
    label: "Visual",
    boxLabel: "Visual Box",
    studentLabel: "Eyes",
    meaning: "Sight and visual input",
    icon: Eye,
    color: "#2E5AA8",          // rich sky-indigo
    bg: "#E1EBFB",
    border: "#B4CBEF",
    accent: "#5A8AE0",
  },
  {
    key: "auditory",
    label: "Auditory",
    boxLabel: "Auditory Box",
    studentLabel: "Ears",
    meaning: "Sound input",
    icon: Ear,
    color: "#6A3EA1",          // vibrant plum
    bg: "#EFE3F8",
    border: "#D2B9EA",
    accent: "#9A6CD1",
  },
  {
    key: "interoceptive",
    label: "Interoceptive",
    boxLabel: "Body Sense Box",
    studentLabel: "Body Sense",
    meaning: "Inside-body signals",
    icon: HeartPulse,
    color: "#B1284A",          // deep rose
    bg: "#FBDDE4",
    border: "#F0B2BF",
    accent: "#E45A78",
  },
  {
    key: "oral",
    label: "Oral / Gustatory",
    boxLabel: "Oral Motor Box",
    studentLabel: "Mouth",
    meaning: "Taste, chew, blow",
    icon: UtensilsCrossed,
    color: "#A0561A",          // burnt honey
    bg: "#FBE6CE",
    border: "#EEC79A",
    accent: "#E3893E",
  },
  {
    key: "olfactory",
    label: "Olfactory",
    boxLabel: "Olfactory Box",
    studentLabel: "Smell",
    meaning: "Smell",
    icon: Flower2,
    color: "#1E7A72",          // vivid teal
    bg: "#D3EFEC",
    border: "#9CD8D1",
    accent: "#3FB5A9",
  },
];

export const SYSTEM_BY_KEY = Object.fromEntries(SYSTEMS.map((s) => [s.key, s]));

export const RESPONSIVITY_OPTIONS = [
  { key: "seek", label: "Seeking", help: "Adds input; activities provide more sensation." },
  { key: "avoid", label: "Avoiding / Sensitive", help: "Reduces input; calming, predictable activities." },
  { key: "neutral", label: "Neutral", help: "No strong preference." },
];

export const ROLE_HOME = {
  therapist: "/therapist",
  student: "/play",
};
